/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of platform activity that qualifies toward a streak window
 * @export
 */
export const StreakActivityType = {
    QUEST_COMPLETION: 'QUEST_COMPLETION',
    ACTIVATION_COMPLETION: 'ACTIVATION_COMPLETION',
    GAME_SESSION: 'GAME_SESSION',
    HUB_ACTIVITY: 'HUB_ACTIVITY',
    COMPETITION_ENTRY: 'COMPETITION_ENTRY',
    XP_EARNED: 'XP_EARNED',
    STREAM_WATCHED: 'STREAM_WATCHED',
    REWARD_CLAIMED: 'REWARD_CLAIMED',
    CUSTOM_EVENT: 'CUSTOM_EVENT',
    CLIP_SHARED: 'CLIP_SHARED'
} as const;
export type StreakActivityType = typeof StreakActivityType[keyof typeof StreakActivityType];


export function instanceOfStreakActivityType(value: any): boolean {
    for (const key in StreakActivityType) {
        if (Object.prototype.hasOwnProperty.call(StreakActivityType, key)) {
            if (StreakActivityType[key as keyof typeof StreakActivityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakActivityTypeFromJSON(json: any): StreakActivityType {
    return StreakActivityTypeFromJSONTyped(json, false);
}

export function StreakActivityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakActivityType {
    return json as StreakActivityType;
}

export function StreakActivityTypeToJSON(value?: StreakActivityType | null): any {
    return value as any;
}

export function StreakActivityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakActivityType {
    return value as StreakActivityType;
}

